import React from 'react'
import {NavLink, useLocation} from "react-router-dom"
import {useAppSelector} from "../../../../hooks/redux"
import {USER_ROLE_ADMIN, USER_ROLE_MANAGER} from "../../../../utils/constants/userRoles"
import classes from './Navigation.module.scss'

interface INavigationProps {
  isFull?: boolean
}

export default function Navigation({isFull = true}: INavigationProps) {

  const location = useLocation()
  const {role_id} = useAppSelector(state => state.auth.user)
  const isExtendedMenu = role_id === USER_ROLE_ADMIN || role_id === USER_ROLE_MANAGER

  const links = isExtendedMenu ? [
    {
      id: 1,
      name: 'Заявки',
      pathname: '/order/',
      icon: 'icon_clipboard'
    },
    {
      id: 2,
      name: 'Сотрудники',
      pathname: '/employee/',
      icon: 'icon_users'
    },
    {
      id: 3,
      name: 'Справочник',
      pathname: '/handbook/',
      icon: 'icon_book'
    }
  ] : [
    {
      id: 1,
      name: 'Заявки',
      pathname: '/order/',
      icon: 'icon_clipboard'
    },
  ]

  const templateList = links.map(link => {

    const active = location.pathname.includes(link.pathname)

    return (
      <NavLink
        to={{
          pathname: link.pathname
        }}
        className={[classes.item, active ? classes.item_active: ''].join(" ")}
        key={link.id}
      >
        <i className={[classes.icon, classes[link.icon]].join(" ")}></i>
        <span className={classes.item_text}>{link.name}</span>
      </NavLink>
    )
  })

  return(
    <div className={[classes.wrap, isFull ? classes.full : classes.compact].join(" ")}>
      {templateList}
    </div>
  )
}